import { IEnv } from './env.type'

export const environment: IEnv = {
  PRODUCTION: true,
  API_PREFIX: 'https://api.dilan-mirror.com/',
  WEBSOCKET_PREFIX: 'wss://api.dilan-mirror.com/',
  CABINET_PREFIX: 'https://my.dilan-mirror.com',
}
